import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { sessionGetItemObj } from '../../../utils/sessionHelpers'
import FundManagerAuditIssuesWidget from '../../../widgets/auditWidgets/fundManagerAuditIssuesWidgets/FundManagerAuditIssuesWidget'
import { getFundManagerAudit } from '../../../redux/actions/fundManagerAudit'

export default function FundManagerAuditIssues() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  // const projectId = sessionStorage.getItem('projectId')
  const auditInfo = sessionGetItemObj('auditInfo')

  useEffect(() => {
    handleGetSchema()
  }, [])
  // console.log('1schema==>', schema)
  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getFundManagerAudit(auditInfo.id, '')
      // console.log('response =>< ', response)
      setSchema(response.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isAudit>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isAudit>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isAudit>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi isShowGoButton />

        <FundManagerAuditIssuesWidget schema={schema} />
        <br />
      </SidebarProposal>
    </div>
  )
}
